export { default } from './TextLinkLayout.js';
//# sourceMappingURL=index.js.map



// WEBPACK FOOTER //
// ./~/wix-style-react/dist/es/src/BaseComponents/TextLinkLayout/index.js